export const formatWishlistCount = (count: number) => {
  const quotByM = count / 1e6;
  if (quotByM >= 1) return `${Math.floor(quotByM * 10) / 10}M`.replace('.', ',');

  const quotByK = count / 1e3;
  if (quotByK >= 1) return `${Math.floor(quotByK * 10) / 10}k`.replace('.', ',');

  return `${count}`;
};

export enum GRAPHQL_ERROR_CODE {
  RATE_LIMIT_EXCEEDED = 'RATE_LIMIT_EXCEEDED',
  CHALLENGE_VALIDATION_FAILED = 'CHALLENGE_VALIDATION_FAILED',
  WISHLIST_TOO_LONG = 'WISHLIST_TOO_LONG',
}

export const getErrorMessage = (errorCode: unknown) => {
  switch (errorCode) {
    case GRAPHQL_ERROR_CODE.RATE_LIMIT_EXCEEDED:
    case GRAPHQL_ERROR_CODE.CHALLENGE_VALIDATION_FAILED:
      return `h24_gql_error_msg_${errorCode.toLowerCase()}`;
    case GRAPHQL_ERROR_CODE.WISHLIST_TOO_LONG:
      return 'h24_wishlist_too_long';
    default:
      return 'h24_something_went_wrong';
  }
};
